import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { produce } from 'immer'
import {
  UpdateCreationSchedulePayload,
  VoohCreationEmission,
  VoohCreationEmissionSliceEmpty,
} from './types'

export const defaultState: VoohCreationEmission = VoohCreationEmissionSliceEmpty

const initialState: VoohCreationEmission = produce(defaultState, draft => draft)

const voohCreationEmissionSlice = createSlice({
  name: 'voohCreationEmission',
  initialState,
  reducers: {
    createVoohCreationEmission(state, action: PayloadAction<UpdateCreationSchedulePayload>) {
      state.creationId = action.payload.creationId
      state.details = action.payload.details
      state.duration = action.payload.duration
      state.mediaFormat = action.payload.mediaFormat
      state.campaign = action.payload.campaign
      state.schedules = { ...initialState.schedules, dates: action.payload.schedules }
      state.locations = {
        ...initialState.locations,
        mediums: action.payload.mediums || [],
        selectedMediums: action.payload.selectedMediums,
      }
      state.frequency = {
        ...initialState.frequency,
        hourFrequency: action.payload.hourFrequency,
      }
      state.file = action.payload.file
      state.thumbnailUrl = action.payload.thumbnailUrl
    },
    updateVoohCreationFrequency(state, action: PayloadAction<number>) {
      state.frequency.hourFrequency = action.payload
    },
    setVoohCreationSchedules(
      state,
      action: PayloadAction<VoohCreationEmission['schedules']['dates']>
    ) {
      state.schedules.dates = action.payload
    },
    toggleShow(state, { payload }: PayloadAction<'schedules' | 'locations' | 'frequency' | 'map'>) {
      state[payload].show = !state[payload].show
    },

    resetVoohCreationScheduleState() {
      return defaultState
    },

    setLoading(
      state,
      action: PayloadAction<{
        key: 'schedules' | 'locations' | 'frequency' | 'map'
        value: boolean
      }>
    ) {
      state[action.payload.key].loading = action.payload.value
    },
  },
})

export const voohCreationEmissionActions = voohCreationEmissionSlice.actions

export default voohCreationEmissionSlice
